<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start">{{ $t("ppjk") }}</h4>
                    <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="createData()">
                      <i class="link-icon mdi mdi-plus"></i>
                      {{ $t("createNew") }}
                    </button>
  
                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px" @click.prevent="downloadData()">
                      <i class="link-icon mdi mdi-download"></i>
                      {{ $t("downloadData") }} .xlsx
                    </button>

                  
  
                  </div>
  
                  <div class="card-body">
                    <vue-good-table title="list-exim-ceisa-ppjk" ref="list-exim-ceisa-ppjk"
                      mode="remote" @on-page-change="onPageChange"
                      @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" 
                     
                      @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                      :isLoading.sync="isLoading" :pagination-options="{
                       
                        enabled: true,
                        perPageDropdown: [10, 50, 100, 1000, 10000],
                        dropdownAllowAll: false,
                      }" :rows="rows" :columns="columns">
   
                   
  
                      <template slot="table-row" slot-scope="props">
                        
                            <span v-if="props.column.field == 'actions'">
                            <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="
                                detailData(props.index, props.row)
                                ">
                                <i class="mdi mdi-eye" style="font-size:16px;color:blue;"></i>
    
                            </a>
                            <a href="#" v-if="permision_role.method_update" title="Edit"
                                @click.prevent="editData(props.index, props.row)">
                                <i class="mdi mdi-square-edit-outline" style="font-size:16px;color:#66d1d1;"></i>
    
                            </a>
     
                            
                            </span>
    
                            <span v-else-if="props.column.field == 'status'">
                            <span v-if="props.row.status == 'ACTIVE'" class="badge bg-info">
                                <h5>{{ props.row.status }}</h5>
                            </span>
                            <span v-else class="badge bg-secondary">
                                <h5>{{ props.row.status }}</h5>
                            </span>
                            </span>
    
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                            
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
   

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
 

export default {
    name: "CeisaPpjkIndex",
    props: {},
    components: {

        "navbar-component": navbarComponent,
        "footer-component": footerComponent,

    },
    data() {
        const startDate = new Date();// new Date();
        const endDate = new Date();

        return {

            dateFilter: {
                startDate,
                endDate,
            },
            asnType: [],
            fetchAsnType: [],
            trackingOrderStatus: [],

            expectedShipmentTime1dateFilter: {
                startDate,
                endDate,
            },

            showModalNow: false,

            opens: "center",
            locale: {
                format: "yyyy-mm-dd H:MM:ss",
            },

            localeDetail: {
                format: "yyyy-mm-dd",
            },

            highlighted: {

                dates: [ // Highlight an array of dates
                new Date(),
                ],

            },

            digit: {
                decimal: ',',
                thousands: '.',
                prefix: ' ',
                suffix: '',
                precision: 5,
                masked: false
            },
            fetchStockCondition: [],
            detailAsn: [],
            orderType: '',
            fetchOrderType: [],
            shelfLifeUnit: {},
            shelfLifeType: {},
            permision_role: [],
            isLoading: false,
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            errors: [],
            userData: "",
            userRole: "",
            companyCode: "",
            fetchStatus: ['ACTIVE', 'DEACTIVE'],
            fetchmultiWhFlag: ['Y', 'N'],
            fetchCustomer: [],
            fetchFulfillment: [],
            customer: "",
            fulfillment: "",
            fetchShelfLifeType: [],
            fetchShelfLifeUnit: [],
            fetchSku: [],
            activeFlag: false,
            shelfLifeFlag: false,
            kitFlag: false,
            freePickGift: false,
            isLoadingStatus: false,
            forms: {ppjk_id:"", nama:"", alamat:"", no_npwp:"", np_ppjk:"",  created_by:"", updated_by:"" , created_at:"", updated_at:""},
            serverParams: {
            columnFilters: {},
            sort: {
                field: "",
                type: "",
            },
            page: 1,
            per_page: 10,
            },
       
            columns: [
    
                {
                    label: this.$t("ppjk_id"),
                    field: "ppjk_id",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: this.$t("ppjk_name"),
                    field: "nama",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: this.$t("no_npwp"),
                    field: "no_npwp",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
    
                {
                    label: this.$t("addwho"),
                    field: "created_by",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                }, 
    
                {
                    label: this.$t("editwho"),
                    field: "updated_by",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                }, 
     
                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },
            ],
            rows: [],
            rowsSelection: [],
            totalRecords: 0,
        };
    },
    watch: {},
    methods: {

        createData() {
            window.location.href = "/exim/ceisa/ppjk/create";
        },
 
        detailData(index, row) {
    
            var params = this.$onRandom(row.ppjk_id);
            window.location.href = "/exim/ceisa/ppjk/detail/" + params;

        },

        downloadData() {
            const baseURI = this.$settings.endPointCeisa + "v1/ppjk/index";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";
            this.isLoading = true;
 
            return this.$http.get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&ppjk_id=${this.serverParams.columnFilters.ppjk_id}&updated_by=${this.serverParams.columnFilters.updated_by}&created_by=${this.serverParams.columnFilters.created_by}&nama=${this.serverParams.columnFilters.nama}&no_npwp=${this.serverParams.columnFilters.no_npwp}&download=download`,
    
                {
                responseType: "blob",
                }
            )
            .then((response) => {
    
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
    
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
                
            }).catch((error) => {

                this.isLoading = false;
  
                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));
  
                } else {
  
  
                  if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
  
                  } else {
  
                    if (error.response) {
                      if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                      } else if (error.response.status === 401) {
                        this.logout();
                      } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                      } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                      } else {
                        this.$router.push('/page-not-found');
                      }
                    }
  
                  }
  
                }
            });

        },

        loadItems() {

            const baseURI = this.$settings.endPointCeisa + "v1/ppjk/index";

            this.isLoading = true;
            

            return this.$http.get(
                baseURI +
                `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&ppjk_id=${this.serverParams.columnFilters.ppjk_id}&updated_by=${this.serverParams.columnFilters.updated_by}&created_by=${this.serverParams.columnFilters.created_by}&nama=${this.serverParams.columnFilters.nama}&no_npwp=${this.serverParams.columnFilters.no_npwp}`,
                { timeout: 10000 })
                .then((response) => {

                    this.isLoading      = false;
                    this.rows           = response.data.datas.data;
                    this.totalRecords   = response.data.datas.total;

                 }).catch((error) => {
                    
                    this.isLoading      = false;
    
                if (error.code == "ECONNABORTED") {
                    
                    this.error(this.$t("check_internet_connection_txt"));
    
                }else{
    
                    if (error.response) {
                        if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                        this.logout();
                        } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                        } else {
                        this.$router.push('/page-not-found');
                        }
                    }
    
                }
            });
        },

  
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },
  
        onColumnFilter(params) {
            this.updateParams(params);
        },
    
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },
    
        onSortChange(params) {
            this.updateParams({
            sort: {
                type: params[0].type,
                field: params[0].field,
            },
            });
        },
  
        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },
    

        editData(index, row) {

            var params = this.$onRandom(row.ppjk_id);
            window.location.href = "/exim/ceisa/ppjk/edit/" + params;

        },


        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.userData = userDatas.sub;
            this.userRole = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'CeisaPpjkController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }

            this.permision_role = rolePermision;

        },

        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },


        cek_message(status,msg){
            if(status=='200'){
                this.success(msg);
            }
        },


    },
    events: {},
    created: function () { },
    mounted() {

        this.fetchIt();


    },
};

</script>
<style scoped>

.required:after {
  content: " *";
  color: red;
}

</style>